import React from "react";
import { Grid, Paper, Typography } from "@material-ui/core";
import { useCompanyStyles } from "./useCompanyStyles";
import logo from "../../assets/images/webappLogo.jpg";
import { Helmet } from "react-helmet-async";
import { useStore } from "../../store";

export const CompanyDetails = () => {
  const classes = useCompanyStyles();
  const [companyDetails] = useStore("companyDetails");

  return (
    <>
      <Helmet>
        <title>Company</title>
      </Helmet>
      <Grid container spacing={2} direction="row">
        <Grid item xs={12}>
          <Grid container>
            <img src={logo} alt="Logo" />
            <Typography className={classes.companyTitle}>
              {companyDetails !== undefined ? companyDetails.name : ""}
            </Typography>
          </Grid>
        </Grid>
        <Grid item xs={12} className={classes.mainGridStyle}>
          <Paper className={classes.paper}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Grid container spacing={2}>
                  <Grid item xs={4}>
                    <Grid container justify="flex-start">
                      <Typography className={classes.textStyles}>
                        Company Code
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid item xs={1}>
                    <Typography className={classes.textStyles}>:</Typography>
                  </Grid>
                  <Grid item xs={7}>
                    <Grid container justify="flex-start">
                      <Typography className={classes.valueStyles}>
                        {companyDetails !== undefined
                          ? companyDetails.code
                          : ""}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              {/* <Grid item xs={12}>
                            <Grid container spacing={2}>
                                <Grid item xs={4}>                                
                                    <Grid container justify="flex-start">
                                    <Typography className={classes.textStyles}>Language</Typography>
                                  </Grid>
                                </Grid>
                                <Grid item xs={1}>
                                <Typography className={classes.textStyles}>:</Typography>
                                </Grid>
                                <Grid item xs={7}>
                                <Grid container justify="flex-start">
                                  <Typography className={classes.valueStyles}>
                                  {companyDetails!==undefined?(
                                         companyDetails.language_name
                                      ):""}
                                  </Typography>
                                  </Grid>
                                </Grid>
                            </Grid>
                        </Grid> */}
              <Grid item xs={12}>
                <Grid container spacing={2}>
                  <Grid item xs={4}>
                    <Grid container justify="flex-start">
                      <Typography className={classes.textStyles}>
                        Status
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid item xs={1}>
                    <Typography className={classes.textStyles}>:</Typography>
                  </Grid>
                  <Grid item xs={7}>
                    <Grid container justify="flex-start">
                      <Typography className={classes.valueStyles}>
                        {companyDetails !== undefined
                          ? companyDetails.status_description
                          : ""}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <Grid container spacing={2}>
                  <Grid item xs={4}>
                    <Grid container justify="flex-start">
                      <Typography className={classes.textStyles}>
                        Currency
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid item xs={1}>
                    <Typography className={classes.textStyles}>:</Typography>
                  </Grid>
                  <Grid item xs={7}>
                    <Grid container justify="flex-start">
                      <Typography className={classes.valueStyles}>
                        {companyDetails !== undefined
                          ? companyDetails.currency_name
                          : ""}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </Grid>
    </>
  );
};
